import { isRouteErrorResponse } from "react-router";
import { Navigate } from "react-router-dom";
import { PageError404, PageError500 } from "../components/index";
import {
  PageContextErrorBoundaryProvider,
  usePageContextErrorBoundary,
} from "../context/index";

function PageErrorBoundaryComponent() {
  const { error, keycloak, pathname, localization } =
    usePageContextErrorBoundary();

  if (error instanceof Error) {
    const pathParts: any = pathname.split("/");
    switch (error.message) {
      case "ACCESS_DENIED":
        keycloak.login();
        return null;

      case "LANG_NOT_SET":
        return <Navigate to={`/${localization.currentLang}${pathname}`} />;

      case "LANG_NOT_AVAILABLE":
        pathParts[1] = localization.currentLang;
        return <Navigate to={`/${pathParts.join("/")}`} />;

      case "LANG_NOT_UPDATE":
        localization.changeLang(pathParts[1]);
        return null;

      default:
    }
  }

  if (
    isRouteErrorResponse(error) &&
    error.status === 404 &&
    localization.currentLang &&
    window.location.pathname
      .split("/")
      .filter(Boolean)
      .includes(localization.currentLang)
  ) {
    return <Navigate to={`/${localization.currentLang}/home`} />;
  }

  if (isRouteErrorResponse(error) && error.status === 404) {
    return <PageError404 />;
  }

  if (error) {
    console.error(error);
  }

  return (
    <>
      <PageError500 />
    </>
  );
}

export default function LayoutPageErrorBoundary() {
  return (
    <>
      <PageContextErrorBoundaryProvider>
        <PageErrorBoundaryComponent />
      </PageContextErrorBoundaryProvider>
    </>
  );
}
